import { defineMessages } from 'react-intl'
const strings = require('./messages.json')
const output = {}
strings.forEach((s) => (output[s.id] = s))
const messages = defineMessages(output)

export default messages
